import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-btn-two-lines',
  templateUrl: './ui-btn-two-lines.component.html',
  styleUrls: ['./ui-btn-two-lines.component.scss']
})
export class UiBtnTwoLinesComponent implements OnInit {
  @Input() icon: string;
  @Input() title: string;
  @Input() info: string;
  @Input() extraClasses: string;
  @Input() disabled: boolean;
  @Input() btnColor: 'primary' | 'secondary' | 'outline-primary' | 'outline-secondary' = 'outline-primary';
  @Input() size: 'lg' | 'xl' = 'xl';

  @Output() onClick = new EventEmitter<void>();

  public colorCssClass: string;
  public cssClassMap = {
    'outline-primary': 'btn-outline-primary',
    'outline-secondary': 'btn-outline-pink',
    primary: 'btn-primary',
    secondary: 'btn-pink',
  };

  ngOnInit(): void {
    this.colorCssClass = this.cssClassMap[this.btnColor] ? this.cssClassMap[this.btnColor] : this.cssClassMap.primary;
  }
}
